export default __webpack_public_path__ + "static/media/worldofpulsation.59a0be28.mov";